import ListView from './ListView';

class DashboardView extends ListView {
    setEntity(entity) {
        this.entity = entity;
        if (!this._name) {
            this._name = entity.name();
        }
        return this;
    }
}

export default DashboardView;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/View/DashboardView.js
 **/